import _isArray from "lodash/isArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Icon } from 'components';
import { tooltipListWrap, tooltipListItem, tableMoreLabel } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var TableMoreColumn = function TableMoreColumn(_ref) {
  var list = _ref.list,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-start' : _ref$position;
  return _isArray(list) ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", null, list[0]), list.length > 1 && ___EmotionJSX(Tooltip, {
    noArrow: true,
    onClick: true,
    placement: position,
    backgroundColor: "white",
    color: "gray50",
    padding: 0,
    border: function border(t) {
      return "1px solid ".concat(t.gray100);
    },
    content: ___EmotionJSX("div", {
      css: tooltipListWrap
    }, list.slice(1).map(function (el, i) {
      return ___EmotionJSX("p", {
        key: i,
        css: tooltipListItem
      }, el);
    }))
  }, ___EmotionJSX("p", {
    css: tableMoreLabel
  }, ___EmotionJSX("span", null, "+ ", list.length - 1, " more"), " ", ___EmotionJSX(Icon, {
    iconName: "la la-angle-down"
  })))) : null;
};

TableMoreColumn.propTypes = {
  list: PropTypes.array,
  position: PropTypes.string
};
export default TableMoreColumn;